import { render } from "./TourViewer.vue?vue&type=template&id=fd472988"
import script from "./TourViewer.vue?vue&type=script&lang=js"
export * from "./TourViewer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/emblematic.es/tour.emblematic.es/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__